import { Divider } from '@heroui/react';
import { manrope } from '@trwl/app/fonts';
import { Product, SearchProductEntity } from '@trwl/backend.api';
import { PageDto } from '@trwl/shared/types';
import { capitalizeText, formatLikes } from '@trwl/util';
import { AddToCart } from '@trwl/widgets/product/productInfo/components/AddToCart';
import { RelationProductsSlider } from '@trwl/widgets/product/productInfo/components/RelationProductsSlider';
import { VariantSelector } from '@trwl/widgets/product/productInfo/components/VariantSelector';
import cn from 'classnames';
import React, { RefObject, useCallback } from 'react';

interface IProductInfo {
  likesCount?: number;
  product: Product;
  slug: string;
  sizeGridRef?: RefObject<HTMLDivElement | null>;
  relationProducts?: PageDto<SearchProductEntity>;
}
export const ProductInfo = ({
  likesCount = 0,
  product,
  sizeGridRef,
  relationProducts,
}: IProductInfo) => {
  const onSizeGridClick = useCallback(() => {
    if (!sizeGridRef || !sizeGridRef.current) return;
    sizeGridRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, [sizeGridRef]);

  return (
    <div className="flex flex-col w-full col-span-5 lg:col-span-2">
      {likesCount > 0 && (
        <div
          className={cn(
            'flex flex-row gap-[6px] text-[12px] font-[500] items-center mb-[10px]',
            manrope.className,
          )}
        >
          <span>Товар добавили в вишлист</span>
          <span className="font-[700]">{formatLikes(likesCount)}</span>
          <span>раз</span>
        </div>
      )}

      <div className="flex flex-col gap-[8px]">
        <h1 className="text-[#282828] text-[28px] font-[500] m-0">
          {capitalizeText(product.title)}
        </h1>
      </div>
      {relationProducts && relationProducts.totalElements > 0 && (
        <div className={'mt-[10px] lg:hidden'}>
          <RelationProductsSlider relationProducts={relationProducts} />
        </div>
      )}

      <div className="flex flex-col gap-[10px] mt-[20px]">
        <VariantSelector product={product} onSizeGridClick={onSizeGridClick} />
        <Divider className={'mt-[25px]'} />
        <AddToCart product={product} />
      </div>
    </div>
  );
};
